import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";

export const PasswordInput = ({ className = "", testid, ...props }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <Input data-testid={testid} type={show ? "text" : "password"} className={`${className} pr-11`} {...props} />
      <button type="button" data-testid={`${testid}-toggle`} onClick={() => setShow((s) => !s)} aria-label={show ? "Hide password" : "Show password"} className="absolute right-3 top-1/2 -translate-y-1/2 text-zinc-500 hover:text-white transition-colors">
        {show ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
};
